import { Component } from '@angular/core';
import { Screen } from 'app/screen';
declare var window: any;
import * as moment from 'moment-timezone';

@Component({
    selector: 'screen-dailyplantsummary-desktop',
    templateUrl: 'dailyplantsummary.html'
})
export class dailyplantsummary_Desktop extends Screen {
    data: any;

    ngOnInit(): void {
        super.ngOnInit();
        // Logic to run when the screen loads goes here.
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        // Logic to run when the screen unloads goes here.
    }

    onDataLoad(data: any): void {
        this.data.screenId = "dailyplantsummary";
        this.data.startDate = this.global.startDate || "2024-01-01";
        this.data.endDate = this.global.endDate || "2024-01-01";
        this.data.startTime = this.global.startTime || "00:00";
        this.data.productCodes.selected = this.global.productCode || '';

        this.loadProductCodes();
        this.updateQuery();
    }

    async ionViewCanLeave() {
        await super.ionViewCanLeave();
        this.global.startDate = this.data.startDate;
        this.global.endDate = this.data.endDate;
        this.global.startTime = this.data.startTime;
        this.global.productCode = this.data.productCodes.selected;
    }

    loadProductCodes() {
        this.fetchWithOptions("https://demo-api.app.smartux.com/api/v2/sensordata/tagquery", {
            method: "POST",
            body: JSON.stringify({
                "QueryString": "SELECT productId " +
                "FROM \"${database}\".\"${table}\" " +
                "WHERE measure_name='FD_RUNNING' AND productId <> '' AND " +
                `time BETWEEN '${this.data.startDate} ${this.data.startTime}:00.000000000' AND '${this.data.endDate} 23:59:59.000000000' ` +
                "GROUP BY productId ORDER BY productId ASC"
            })
        }, (response) => {
            this.data.productCodes.options = response.map(row => ({ label: row.productId.toUpperCase(), value: row.productId }));
            //this.data.productCodes.options.sort((a, b) => a.label.localeCompare(b.label));
            this.data.productCodes.options.unshift({
                label: 'All',
                value: ''
            });
        }, (error) => {
            console.error("Error", error);
            this.alert(error.message);
        });
    }

    updateQuery() {
        // Logic to run when the screen's data is updated goes here.
        this.fetchWithOptions("https://demo-api.app.smartux.com/api/v2/sensordata/tagquery", {
            method: "POST",
            body: JSON.stringify({
                "QueryString": "SELECT time, measure_name, productId, batchId, mcrunning, anomalycount, numvalue " +
                "FROM \"${database}\".\"${table}\" " +
                "WHERE measure_name='FD_RUNNING' AND " +
                (this.data.productCodes.selected ? `productId='${this.data.productCodes.selected}' AND ` : '') +
                `time BETWEEN '${this.data.startDate} ${this.data.startTime}:00.000000000' AND '${this.data.endDate} 23:59:59.999999999' ORDER BY time ASC`
            })
        }, (response) => {
            this.processResponse(response);
        }, (error) => {
            console.error("Error", error);
            this.alert(error.message);
        });
    }

    changeDateTimeInput() {
        this.data.invalidDateQuery = !this.data.startDate || !this.data.endDate || !this.data.startTime;

        if (!this.data.invalidDateQuery) {
            if (new Date(this.data.endDate) < new Date(this.data.startDate)) {
                this.data.endDate = this.data.startDate;
            }
            this.updateQuery();
        }
    }

    changeProductCode() {
        this.updateQuery();
    }

    processResponse(arrTimeSeries) {
        this.data.summaryTableData = [];

        // Filter events down to the ones we care about (start/stop events)
        let lastPushedEntry = null;
        for (let i = 0; i < arrTimeSeries.length; i++) {
            let taggedEvent = arrTimeSeries[i];
            // If it's the first event, or different from the last event, then it's important...
            if (i == 0 || taggedEvent.mcrunning !== lastPushedEntry.mcrunning || (taggedEvent.mcrunning == "1" && (taggedEvent.productId !== lastPushedEntry.productId || taggedEvent.batchId !== lastPushedEntry.batchId))) {
                lastPushedEntry = (taggedEvent.mcrunning == "1") ?
                    {
                        ...taggedEvent,
                        time: taggedEvent.time.substring(0, taggedEvent.time.indexOf('.')),
                        event: "Started at",
                        _count: 1
                    } : {
                        ...taggedEvent,
                        productId: lastPushedEntry ? lastPushedEntry.productId : '',
                        batchId: lastPushedEntry ? lastPushedEntry.batchId : '',
                        time: taggedEvent.time.substring(0, taggedEvent.time.indexOf('.')),
                        event: "Stopped at",
                        _count: 1
                    };
                this.data.summaryTableData.push(lastPushedEntry);
            } else if (lastPushedEntry) {
                lastPushedEntry.time_end = taggedEvent.time;
                lastPushedEntry._count++;
            }
        }

        // Now gather stats.
        this.data.runtimeStats = {
            totalTime: 0,
            stopTime: 0,
            runTime: 0,
            numStops: 0,
            avgDownTime: 0
        };

        this.data.chartData = [];

        let dayRuntimes = {};
        for (const [index, orderedEvents] of this.data.summaryTableData.entries()) {
            let timeEnd;
            if (orderedEvents.mcrunning == "1" && this.data.summaryTableData[index + 1] && this.data.summaryTableData[index + 1].mcrunning == "0" && this.data.summaryTableData[index + 1].time) {
                timeEnd = this.data.summaryTableData[index + 1].time;
            } else if (orderedEvents.mcrunning == "0" && this.data.summaryTableData[index + 1] && this.data.summaryTableData[index + 1].mcrunning == "1" && this.data.summaryTableData[index + 1].time) {
                timeEnd = this.data.summaryTableData[index + 1].time;
            } else if (orderedEvents.time_end) {
                timeEnd = orderedEvents.time_end;
            } else {
                timeEnd = orderedEvents.time;
            }
            let timeEvent = moment(orderedEvents.time);
            let timeDiff = moment(timeEnd).diff(timeEvent);

            let day = timeEvent.format("YYYY-MM-DD");
            if (!dayRuntimes[day]) {
                dayRuntimes[day] = {
                    name: day,
                    series: [
                        { name: 'Run Time', value: 0 },
                        { name: 'Stop Time', value: 0 }
                    ]
                };
                this.data.chartData.push(dayRuntimes[day]);
            }

            if (orderedEvents.mcrunning == "0") {
                this.data.runtimeStats.numStops++;
                this.data.runtimeStats.stopTime += timeDiff;
                dayRuntimes[day].series[1].value += timeDiff;
            } else if (orderedEvents.mcrunning == "1") {
                this.data.runtimeStats.runTime += timeDiff;
                dayRuntimes[day].series[0].value += timeDiff;
            }
        }

        for (let i = 0; i < this.data.chartData.length; i++) {
            this.data.chartData[i].series[0].value = moment.duration(this.data.chartData[i].series[0].value).as('minutes');
            this.data.chartData[i].series[1].value = moment.duration(this.data.chartData[i].series[1].value).as('minutes');
        }

        this.data.runtimeStats.totalTime = this.data.runtimeStats.stopTime + this.data.runtimeStats.runTime;
        this.data.runtimeStats.upTimePct = (100 * this.data.runtimeStats.runTime / this.data.runtimeStats.totalTime).toFixed(2);
        this.data.runtimeStats.downTimePct = (100 * this.data.runtimeStats.stopTime / this.data.runtimeStats.totalTime).toFixed(2);

        this.data.runtimeStats.avgDownTime = `${this.data.runtimeStats.downTimePct}%`;
        this.data.runtimeStats.stopTime = moment.duration(this.data.runtimeStats.stopTime).as('minutes');
        this.data.runtimeStats.runTime = moment.duration(this.data.runtimeStats.runTime).as('minutes');
        this.data.runtimeStats.totalTime = moment.duration(this.data.runtimeStats.totalTime).as('minutes');
    }

    onBackButton(): boolean {
        //(Android) returns :
        // true - handle the event in App Hooks
        // false - stop the event propogation
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/pages/dailyplantsummary/Desktop/dailyplantsummary.ts